export const LOGIN = '/login'
export const UPDATE_PASSWORD = '/update-password'
export const REGISTER = '/register'
export const EMAIL_VERIFICATION = '/verify-email'
export const RESET_PASSWORD = '/reset-password'
export const RESET_PASSWORD_REQUEST = '/reset-password-request'
export const PROFILE_COMPLETION = '/profile-completion'
export const PROFILE = '/profile'
